export default {
  item: {
    top_page: 'トップ',
    my_page: 'マイページ',
    faq: 'FAQ',
    order_history: 'お買物履歴',
    logout: 'ログアウト',
  },
};
